
const tbAdministrationStateConstants = {
    rootStateName: "tbAdministration",
    managementPage: {
        pageTitleBase: "TrackerBase: Subscription Management",
        stateName: "subscriptionManagement"
    }
};

export default Object.freeze(tbAdministrationStateConstants);


//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/Constants.js
// module id = WMC4
// module chunks = 1